var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-wrapper"},[_c('button',_vm._g({staticClass:"button",attrs:{"type":"button"}},_vm.$listeners),[_vm._v("ギグベースを始める")])])}
var staticRenderFns = []

export { render, staticRenderFns }